import { useTranslation } from 'react-i18next';

import { OrgMemberWithProfile } from '@/features/org/api/get-org-members';
import { DefaultMemberInvitationList } from '@/features/projects/create-project/components/default-member-invitation-list';
import { ProjectMemberInvitationList } from '@/features/projects/create-project/components/project-member-invitation-list';
import { useOrgMembersForProject } from '@/features/projects/create-project/hooks/use-org-members-for-project';
import PlusIcon from '@/shared/assets/plus-white.svg?react';
import {
  FlowBackButton,
  FlowSubmitButton,
} from '@/shared/components/flow/flow-actions';
import { Button } from '@/shared/components/ui/button';
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/shared/components/ui/card';

export interface AcceptPartnerInvitationOverviewFormProps {
  invitations: OrgMemberWithProfile[];
  onAddMore: () => void;
  onBack: () => void;
  onSubmitAll: () => void;
  handleRemove: (email: string) => void;
}

export const AcceptPartnerInvitationOverviewForm = ({
  invitations,
  onAddMore,
  onBack,
  onSubmitAll,
  handleRemove,
}: AcceptPartnerInvitationOverviewFormProps) => {
  const { t } = useTranslation('subproject', {
    keyPrefix: 'AcceptInvitation.InviteMembersForm',
  });

  const { data: orgMembers } = useOrgMembersForProject();

  return (
    <Card variant="form" wrapWithStars>
      <CardHeader>
        <CardTitle>{t('title')}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex flex-col gap-6">
          <DefaultMemberInvitationList />

          {invitations.length > 0 && (
            <ProjectMemberInvitationList
              memberIdsToInvite={invitations.map(
                (invitation) => invitation.member_id,
              )}
              orgMembers={orgMembers || []}
              onRemove={handleRemove}
            />
          )}

          <Button
            variant="outline"
            onClick={onAddMore}
            btnType="secondary"
            className="self-end bg-custom-soft-purple text-white"
            gradientBorder="whiteToHalfWhite"
          >
            <PlusIcon className="h-[19px] w-[18px]" />
            {t('add_member_button')}
          </Button>
        </div>
      </CardContent>
      <CardFooter>
        <FlowBackButton onClick={onBack}>
          {t('back_button_label')}
        </FlowBackButton>
        <FlowSubmitButton onClick={onSubmitAll}>
          {t('submit_button_label')}
        </FlowSubmitButton>
      </CardFooter>
    </Card>
  );
};
